export default "__VITE_ASSET__VmwTqkdM__"